export const addFood = [
  { name: "Apple", calories: 95, emoji: "🍎" },
  { name: "Banana", calories: 105, emoji: "🍌" },
  { name: "Greek Yogurt", calories: 130, emoji: "🥛" },
  { name: "Almonds (1oz)", calories: 160, emoji: "🥜" },
  { name: "Chicken Breast", calories: 185, emoji: "🍗" },
  { name: "Broccoli", calories: 55, emoji: "🥦" },
  { name: "Rice (1 cup)", calories: 205, emoji: "🍚" },
  { name: "Avocado", calories: 234, emoji: "🥑" },
];
